import type { ModuleRoute } from '../../util'

export const enum STUDENT_VERSION_3_MODULE {
  ThesisAssistant = 40001,
  GuidanceProcess = 40002,
  MyThesis = 40003,
  MyOrder = 40004,
  ThesisServicePage = 40005,
}
export const enum STUDENT_VERSION_3_MODULE_NAME {
  ThesisAssistant = 'studentThesisAssistant',
  GuidanceProcess = 'studentGuidanceProcess',
  MyThesis = 'studentMyThesis',
  MyOrder = 'studentMyOrder',
  ThesisServicePage = 'studentThesisServicePage',
}
export const STUDENT_VERSION_3_MODULE_NAME_LIST: string[] = [
  STUDENT_VERSION_3_MODULE_NAME.ThesisAssistant,
  STUDENT_VERSION_3_MODULE_NAME.GuidanceProcess,
  STUDENT_VERSION_3_MODULE_NAME.MyThesis,
  STUDENT_VERSION_3_MODULE_NAME.MyOrder,
]
export const studentVersion3RouteMap = {
  [STUDENT_VERSION_3_MODULE.ThesisAssistant]: {
    path: 'thesisAssistant',
    name: STUDENT_VERSION_3_MODULE_NAME.ThesisAssistant,
    component: () => import('@/views/student/v3/ThesisAssistant.vue'),
    meta: {
      requiresAuth: true,
      roleStudent: true,
      modulePath: [STUDENT_VERSION_3_MODULE.ThesisAssistant],
      moduleChildren: [],
      category: 'thesisAssistant',
    },
  },
  [STUDENT_VERSION_3_MODULE.GuidanceProcess]: {
    path: 'guidanceProcess',
    name: STUDENT_VERSION_3_MODULE_NAME.GuidanceProcess,
    component: () => import('@/views/student/v3/GuidanceProcess.vue'),
    meta: {
      requiresAuth: true,
      roleStudent: true,
      modulePath: [STUDENT_VERSION_3_MODULE.GuidanceProcess],
      moduleChildren: [],
      category: 'guidanceProcess',
    },
  },
  [STUDENT_VERSION_3_MODULE.MyThesis]: {
    path: 'myThesis',
    name: STUDENT_VERSION_3_MODULE_NAME.MyThesis,
    component: () => import('@/views/student/v3/MyThesis.vue'),
    meta: {
      requiresAuth: true,
      roleStudent: true,
      modulePath: [STUDENT_VERSION_3_MODULE.MyThesis],
      moduleChildren: [],
      category: 'thesisAssistant',
    },
  },
  [STUDENT_VERSION_3_MODULE.MyOrder]: {
    path: 'myOrder',
    name: STUDENT_VERSION_3_MODULE_NAME.MyOrder,
    component: () => import('@/views/student/v3/MyOrder.vue'),
    meta: {
      requiresAuth: true,
      roleStudent: true,
      modulePath: [STUDENT_VERSION_3_MODULE.MyOrder],
      moduleChildren: [],
      category: '',
    },
  },
  [STUDENT_VERSION_3_MODULE.ThesisServicePage]: {
    path: 'thesisServicePage',
    name: STUDENT_VERSION_3_MODULE_NAME.ThesisServicePage,
    component: () => import('@/views/student/v3/ThesisServicePage.vue'),
    meta: {
      requiresAuth: true,
      roleStudent: true,
      modulePath: [STUDENT_VERSION_3_MODULE.ThesisServicePage],
      moduleChildren: [],
      category: '',
    },
  },
}

export default {
  path: '/:symbol/platformV3/',
  component: () => import('@/components/student/layout/PlatformLayoutV3.vue'),
  children: Object.values(studentVersion3RouteMap as ModuleRoute),
}

